import { render, staticRenderFns } from "./CartonItem.vue?vue&type=template&id=58cefd12&scoped=true"
import script from "./CartonItem.vue?vue&type=script&lang=js"
export * from "./CartonItem.vue?vue&type=script&lang=js"
import style0 from "./CartonItem.vue?vue&type=style&index=0&id=58cefd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cefd12",
  null
  
)

export default component.exports